import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import Chip from '@mui/material/Chip'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded'

import WcRoundedIcon from '@mui/icons-material/WcRounded'
import CakeRoundedIcon from '@mui/icons-material/CakeRounded'
import PregnantWomanRoundedIcon from '@mui/icons-material/PregnantWomanRounded'
import LiquorRoundedIcon from '@mui/icons-material/LiquorRounded'
import BabyChangingStationRoundedIcon from '@mui/icons-material/BabyChangingStationRounded'
import { useTranslation } from 'react-i18next'

export default function Features() {
      const { t } = useTranslation()

      const items = [
            {
                  icon: <WcRoundedIcon />,
                  title: t('landing_page_features_wedding_title'),
                  description: t('landing_page_features_wedding_description'),
                  imageLight: 'url("/images/tzo_bride.jpg")',
                  imageDark: 'url("/images/tzo_bride.jpg")',
            },
            {
                  icon: <BabyChangingStationRoundedIcon />,
                  title: t('landing_page_features_babtism_title'),
                  description: t('landing_page_features_babtism_description'),
                  imageLight: 'url("/images/father-with-daughter.jpg")',
                  imageDark: 'url("/images/father-with-daughter.jpg")',
            },
            {
                  icon: <CakeRoundedIcon />,
                  title: t('landing_page_features_birthday_title'),
                  description: t('landing_page_features_birthday_description'),
                  imageLight: 'url("/images/high-angle-hand-holding-smartphone.jpg")',
                  imageDark: 'url("/images/high-angle-hand-holding-smartphone.jpg")',
            },
            {
                  icon: <PregnantWomanRoundedIcon />,
                  title: t('landing_page_features_gender_reveal_title'),
                  description: t('landing_page_features_gender_reveal_description'),
                  imageLight: 'url("/images/front-view-pregnant-woman-home.jpg")',
                  imageDark: 'url("/images/front-view-pregnant-woman-home.jpg")',
            },
            {
                  icon: <LiquorRoundedIcon />,
                  title: t('landing_page_features_corporate_event_title'),
                  description: t('landing_page_features_corporate_event_description'),
                  imageLight:
                        'url("/images/man-taking-photo-his-friends-new-year-s-eve-party.jpg")',
                  imageDark: 'url("/images/man-taking-photo-his-friends-new-year-s-eve-party.jpg")',
            },
      ]
      const [selectedItemIndex, setSelectedItemIndex] = React.useState(0)

      const handleItemClick = (index: number) => {
            setSelectedItemIndex(index)
      }

      const selectedFeature = items[selectedItemIndex]

      return (
            <Container id="features" sx={{ py: { xs: 8, sm: 16 } }}>
                  <Grid container spacing={6}>
                        <Grid item xs={12} md={6}>
                              <div>
                                    <Typography component="h2" variant="h4" color="text.primary">
                                          {t('landing_page_features_title')}
                                    </Typography>
                                    <Typography
                                          variant="body1"
                                          color="text.secondary"
                                          sx={{ mb: { xs: 2, sm: 4 } }}
                                    >
                                          {t('landing_page_features_description')}
                                    </Typography>
                              </div>
                              <Grid
                                    container
                                    item
                                    gap={1}
                                    sx={{ display: { xs: 'auto', sm: 'none' } }}
                              >
                                    {items.map(({ title }, index) => (
                                          <Chip
                                                key={index}
                                                label={title}
                                                onClick={() => handleItemClick(index)}
                                                sx={{
                                                      borderColor: (theme) => {
                                                            if (theme.palette.mode === 'light') {
                                                                  return selectedItemIndex === index
                                                                        ? 'primary.light'
                                                                        : ''
                                                            }
                                                            return selectedItemIndex === index
                                                                  ? 'primary.light'
                                                                  : ''
                                                      },
                                                      background: (theme) => {
                                                            if (theme.palette.mode === 'light') {
                                                                  return selectedItemIndex === index
                                                                        ? 'none'
                                                                        : ''
                                                            }
                                                            return selectedItemIndex === index
                                                                  ? 'none'
                                                                  : ''
                                                      },
                                                      backgroundColor:
                                                            selectedItemIndex === index
                                                                  ? 'primary.main'
                                                                  : '',
                                                      '& .MuiChip-label': {
                                                            color:
                                                                  selectedItemIndex === index
                                                                        ? '#fff'
                                                                        : '',
                                                      },
                                                }}
                                          />
                                    ))}
                              </Grid>
                              <Box
                                    component={Card}
                                    variant="outlined"
                                    sx={{
                                          display: { xs: 'auto', sm: 'none' },
                                          mt: 4,
                                    }}
                              >
                                    <Box
                                          sx={{
                                                backgroundImage: (theme) =>
                                                      theme.palette.mode === 'light'
                                                            ? items[selectedItemIndex].imageLight
                                                            : items[selectedItemIndex].imageDark,
                                                backgroundSize: 'cover',
                                                backgroundPosition: 'center',
                                                minHeight: 280,
                                          }}
                                    />
                                    <Box sx={{ px: 2, pb: 2 }}>
                                          <Typography
                                                color="text.primary"
                                                variant="body2"
                                                fontWeight="bold"
                                          >
                                                {selectedFeature.title}
                                          </Typography>
                                          <Typography
                                                color="text.secondary"
                                                variant="body2"
                                                sx={{ my: 0.5 }}
                                          >
                                                {selectedFeature.description}
                                          </Typography>
                                          {/* <Link
                                                color="primary"
                                                variant="body2"
                                                fontWeight="bold"
                                                sx={{
                                                      display: 'inline-flex',
                                                      alignItems: 'center',
                                                      '& > svg': { transition: '0.2s' },
                                                      '&:hover > svg': {
                                                            transform: 'translateX(2px)',
                                                      },
                                                }}
                                          >
                                                <span>{t('landing_page_features_learn_more')}</span>
                                                <ChevronRightRoundedIcon
                                                      fontSize="small"
                                                      sx={{ mt: '1px', ml: '2px' }}
                                                />
                                          </Link> */}
                                    </Box>
                              </Box>
                              <Stack
                                    direction="column"
                                    justifyContent="center"
                                    alignItems="flex-start"
                                    spacing={2}
                                    useFlexGap
                                    sx={{ width: '100%', display: { xs: 'none', sm: 'flex' } }}
                              >
                                    {items.map(({ icon, title, description }, index) => (
                                          <Card
                                                key={index}
                                                variant="outlined"
                                                component={Button}
                                                onClick={() => handleItemClick(index)}
                                                sx={{
                                                      p: 3,
                                                      height: 'fit-content',
                                                      width: '100%',
                                                      background: 'none',
                                                      backgroundColor:
                                                            selectedItemIndex === index
                                                                  ? 'action.selected'
                                                                  : undefined,
                                                      borderColor: (theme) => {
                                                            if (theme.palette.mode === 'light') {
                                                                  return selectedItemIndex === index
                                                                        ? 'primary.light'
                                                                        : 'grey.200'
                                                            }
                                                            return selectedItemIndex === index
                                                                  ? 'primary.dark'
                                                                  : 'grey.800'
                                                      },
                                                }}
                                          >
                                                <Box
                                                      sx={{
                                                            width: '100%',
                                                            display: 'flex',
                                                            textAlign: 'left',
                                                            flexDirection: {
                                                                  xs: 'column',
                                                                  md: 'row',
                                                            },
                                                            alignItems: { md: 'center' },
                                                            gap: 2.5,
                                                      }}
                                                >
                                                      <Box
                                                            sx={{
                                                                  color: (theme) => {
                                                                        if (
                                                                              theme.palette.mode ===
                                                                              'light'
                                                                        ) {
                                                                              return selectedItemIndex ===
                                                                                    index
                                                                                    ? 'primary.main'
                                                                                    : 'grey.300'
                                                                        }
                                                                        return selectedItemIndex ===
                                                                              index
                                                                              ? 'primary.main'
                                                                              : 'grey.700'
                                                                  },
                                                            }}
                                                      >
                                                            {icon}
                                                      </Box>
                                                      <Box sx={{ textTransform: 'none' }}>
                                                            <Typography
                                                                  color="text.primary"
                                                                  variant="body2"
                                                                  fontWeight="bold"
                                                            >
                                                                  {title}
                                                            </Typography>
                                                            <Typography
                                                                  color="text.secondary"
                                                                  variant="body2"
                                                                  sx={{ my: 0.5 }}
                                                            >
                                                                  {description}
                                                            </Typography>
                                                            {/* <Link
                                                                  color="primary"
                                                                  variant="body2"
                                                                  fontWeight="bold"
                                                                  sx={{
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        '& > svg': {
                                                                              transition: '0.2s',
                                                                        },
                                                                        '&:hover > svg': {
                                                                              transform:
                                                                                    'translateX(2px)',
                                                                        },
                                                                  }}
                                                                  onClick={(event) => {
                                                                        event.stopPropagation()
                                                                  }}
                                                            >
                                                                  <span>
                                                                        {t(
                                                                              'landing_page_features_learn_more'
                                                                        )}
                                                                  </span>
                                                                  <ChevronRightRoundedIcon
                                                                        fontSize="small"
                                                                        sx={{
                                                                              mt: '1px',
                                                                              ml: '2px',
                                                                        }}
                                                                  />
                                                            </Link> */}
                                                      </Box>
                                                </Box>
                                          </Card>
                                    ))}
                              </Stack>
                        </Grid>
                        <Grid
                              item
                              xs={12}
                              md={6}
                              sx={{ display: { xs: 'none', sm: 'flex' }, width: '100%' }}
                        >
                              <Card
                                    variant="outlined"
                                    sx={{
                                          height: '100%',
                                          width: '100%',
                                          display: { xs: 'none', sm: 'flex' },
                                          pointerEvents: 'none',
                                    }}
                              >
                                    <Box
                                          sx={{
                                                m: 'auto',
                                                width: '100%',
                                                height: '100%',
                                                backgroundSize: 'cover',
                                                backgroundPosition: 'center',
                                                backgroundImage: (theme) =>
                                                      theme.palette.mode === 'light'
                                                            ? items[selectedItemIndex].imageLight
                                                            : items[selectedItemIndex].imageDark,
                                          }}
                                    />
                              </Card>
                        </Grid>
                  </Grid>
            </Container>
      )
}
